export type FetchInterceptHooks = {
  onProgress?: (progress: number) => void;
};

type Resource = Parameters<typeof fetch>[0];
type FetchOptions = Parameters<typeof fetch>[1];

export async function fetchBlobWithIntercept(
  ...args: [Resource, FetchOptions & FetchInterceptHooks]
) {
  const [resource, options] = args;

  console.time(`fetch ${resource}`);
  const response = await fetch(...args);
  const reader = response.body?.getReader();
  const contentLength = Number(response.headers.get("Content-Length"));
  let receivedLength = 0;
  const chunks = [];
  let isStreaming = true;
  while (isStreaming) {
    if (!reader) {
      console.warn("Response body is null");
      break;
    }
    const { done, value } = await reader.read();
    if (done) {
      isStreaming = false;
      break;
    }
    chunks.push(value);
    receivedLength += value.length;
    if (options?.onProgress) {
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      const progress = Math.floor((receivedLength * 100) / contentLength);
      options.onProgress(progress);
    }
  }

  const chunksAll = new Uint8Array(receivedLength);
  let position = 0;
  for (const chunk of chunks) {
    chunksAll.set(chunk, position);
    position += chunk.length;
  }

  const result = new Blob([chunksAll]);

  console.timeEnd(`fetch ${resource}`);
  return new Response(result, {
    ...response,
  });
}
